import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  gap: 30px;
  padding: 10px;

  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;